module.exports = __webpack_public_path__ + "img/9.d99ffe26.svg";